import UPA from 'actions/updatePasswordActions';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ Request } = ssCommonUtils,
init = {
    request: new Request(),
    oldPassword: '',
    newPassword1: '',
    newPassword2: ''
}

export default (state=init, action) => {
    switch(action.type) {
        case UPA.UPDATE_PASSWORD:
            switch(action.payload.type) {
                case 'oldPassword': return {...state, oldPassword: action.payload.input };
                case 'newPassword1': return {...state, newPassword1: action.payload.input };
                case 'newPassword2': return {...state, newPassword2: action.payload.input };
            }

        case UPA.UPDATE_NEW_PASSWORD_PENDING:
            return {...state, request: {...state.request, status: 'pending' }};

        case UPA.UPDATE_NEW_PASSWORD_SUCCESS:
            return {...state, request: {...state.request, status: 'success' }};

        case UPA.UPDATE_NEW_PASSWORD_FAILURE:
            return {...state, request: {...state.request,
                status: 'failure',
                error: action.error ? true : false,
                code: action.error ? action.payload.status : null
            }};

        case UPA.UPDATE_NEW_EMAIL_PENDING:
            return {...state, request: {...state.request, status: 'pending' }};

        case UPA.UPDATE_NEW_EMAIL_SUCCESS:
            return {...state, request: {...state.request, status: 'success' }};

        case UPA.UPDATE_NEW_EMAIL_FAILURE:
            return {...state, request: {...state.request,
                status: 'failure',
                error: action.error ? true : false,
                code: action.error ? action.payload.status : null
            }};

        default: return {...state};
    }
}
